module.exports = __webpack_public_path__ + "img/tcndxq_img5_gray-6.a30127dc.png";